export default "__VITE_ASSET___2QQ399p__"